export enum ProductType {
  luce = 'Luce',
  gas = 'Gas',
  luceEgas = 'Luce & Gas',
}
export enum LightRate {
  mono = 'Monoraria',
  bi = 'Bioraria',
  tri = 'Trioraria'
}
export enum Source {
  eco = 'Ecologica',
  casaOnline = 'Casa Online',
  secondaCasa = 'Seconda Casa',
  placet = 'Placet',
  accendiFutura = 'Accendi Futura',
  casa = 'Casa',
  casaAgile = 'Casa Agile',
  casaAgileEcologica = 'Casa Agile Ecologica',
  accendiUnicaCoop = 'Unica COOP'
}
export enum PriceType {
  fisso = 'Fisso',
  variabile = 'Variabile',
}
export enum Duration {
  m24 = '24 Mesi',
  m12 = '12 Mesi',
  NA = 'N/A',
}
export enum VulnerabilityType {
  socialBonus = 'Bonus Sociale',
  disability = 'Disabilità',
  housingEmergency = 'Emergenza abitativa',
  anagraficAge = 'Età anagrafica',
}

const productFamilyendpoint = 'product-families';

export interface ProductFamily {
  _id: string;
  name: string;
  differentAddress: boolean;
  partnershipAllowed: boolean;
  promotionAllowed: boolean;
  ridDisabled: boolean;
  librettoDisabled: boolean;
  bollettinoDisabled: boolean;
  postaDisabled: boolean;
  monoLightDescription: string;
  monoGasDescription: string;
  dualLightDescription: string;
  dualGasDescription: string;
  monoLightPlacetFissoDescription: string;
  monoLightPlacetVariabileDescription: string;
  monoGasPlacetVariabileDescription: string;
  monoGasPlacetFissoDescription: string;
  productSource: string;
}

export const productEndpoint = 'product';

export interface Product {
  _id: string;
  name: string;
  slug: string;
  family: ProductFamily;
  validity: string;
  type: ProductType;
  lightRate: LightRate;
  source: Source;
  priceType: PriceType;
  lightPrice1: string;
  lightPrice2: string;
  lightPriceVariable: string;
  gasPrice: string;
  duration: Duration;
  durationChangeable: boolean;
  greenEnergy: boolean;
  greenEnergyChangable: boolean;
  lightRateChangeable: boolean;
  summary: string;
  technicalCondition: string;
  generalCondition: string;
}



// WEBPACK FOOTER //
// ./src/app/models/product.ts